import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";

import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";

import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useLocation, useNavigate } from "react-router-dom";
import SelectAllTransferList from "../../extra/TransferList";
import {
  getAllUsers,
  getUser,
  getUserChannels,
  getUserProfile,
  updateProfile,
} from "../../store/user/user.action";
import { setTheGoldenBadgeUser } from "../../store/goldenBadge/badge.action";
import SelectAllTransferListForBage from "../../extra/TransferListForBadge";
import DragAndDropTransferList from "../../extra/Draganddroplist";

export default function Premiumbadgeusers(props) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(25);
  const { startDate, endDate } = props;
  const { allUsers } = useSelector((state) => state.user);
  const [leftItems, setLeftItems] = useState([]);
  const [rightItems, setRightItems] = useState([]);
  useEffect(() => {
    //premium Users
    const premiumUsersWithIndexes = allUsers
      .map((user, index) => ({
        name: user.fullName,
        isPremiumPlan: user.isPremiumPlan,
        isChannel: user.isChannel,
        id: user._id,
      }))
      .filter((user) => user.isPremiumPlan && user.name != null)
      .map((user) => ({
        name: user.name,
        id: user.id,
      }));
    //nonPremiumUsers
    const nonPremiumUsersWithIndex = allUsers
      .map((user, index) => ({
        name: user.fullName,
        isPremiumPlan: user.isPremiumPlan,
        id: user._id,
      }))
      .filter((user) => !user.isPremiumPlan && user.name != null)
      .map((user) => ({
        name: user.name,
        id: user.id,
        isChannel: user.isChannel,
      }));
    if (premiumUsersWithIndexes && nonPremiumUsersWithIndex) {
      setRightItems(premiumUsersWithIndexes);
      setLeftItems(nonPremiumUsersWithIndex);
    }
  }, [allUsers]);
  useEffect(() => {
    dispatch(getAllUsers("realUser", page, size, startDate, endDate));
  }, [dispatch, startDate, endDate]);
  const updateTransferList = (userId, isPremimumValue) => {
    dispatch(updateProfile(userId, isPremimumValue));
  };
  return (
    <>
      <div className="userSetting">
        <div className="dashboardHeader primeHeader mb-3 p-0"></div>
        <div className="row">
          <div className="col-4">
            <div className="mb-0 pb-2">
              <NewTitle titleShow={true} name={"Premium Badge Users"} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="general-setting fake-user video-upload-page mt-3">
            <div className=" userSettingBox">
              <form>
                <div className="row d-flex  align-items-center">
                  <div className="col-6">
                    <h5 className="mb-0 text-nowrap">Premium Badge Users</h5>
                  </div>
                  {/* <div className="col-6 d-flex justify-content-end">
                  <Button
                    btnName={"Back"}
                    newClass={"back-btn"}
                    onClick={handleClose}
                  />
                </div> */}
                  <div
                    className="col-12 d-flex justify-content-end align-items-center"
                    style={{
                      paddingTop: "23px",
                      marginTop: "11px",
                      borderTop: "1px solid #c9c9c9",
                    }}
                  ></div>
                  <div className="row">
                    <div className="col-12 d-flex justify-content-center align-items-center">
                      <DragAndDropTransferList
                        ListOneName={"Non Premium User"}
                        ListTwoName={"Premium User"}
                        leftItems={leftItems}
                        setLeftItems={setLeftItems}
                        rightItems={rightItems}
                        setRightItems={setRightItems}
                        updateTransferList={updateTransferList}
                      />
                    </div>

                    <div
                      className="col-12 d-flex justify-content-end align-items-center"
                      style={{
                        paddingTop: "32px",
                        marginTop: "40px",
                        borderTop: "1px solid #c9c9c9",
                      }}
                    ></div>
                    {/* <div className="col-12 d-flex justify-content-end align-items-center">
                    <Button
                      onClick={handleSubmit}
                      newClass={"submit-btn"}
                      btnName={"Submit"}
                      type={"button"}
                    />
                  </div> */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
